import { createAction } from '@reduxjs/toolkit';
import { memoize } from 'lodash-es';
import type { TreeNode } from 'tree-model';

import type { TreeReducerId, TreeReducerModel } from './types';

/**
 * The same tree duck backs several independent trees (the collection browser,
 * the storage browser, each collection picker). Every one gets its own action
 * creators so an action only reaches the tree it was dispatched for; they are
 * memoized on the id so creators compare equal across calls.
 */
export const treeActions = memoize((reducerId: TreeReducerId) => ({
  addBranches: createAction<TreeNode<TreeReducerModel>>(
    `tree/${reducerId}/addBranches`,
  ),
  modifyBranch: createAction<TreeNode<TreeReducerModel>>(
    `tree/${reducerId}/modifyBranch`,
  ),
  removeBranch: createAction<TreeNode<TreeReducerModel>>(
    `tree/${reducerId}/removeBranch`,
  ),
  clearTree: createAction(`tree/${reducerId}/clearTree`),
  setTreeSearchLoading: createAction<boolean>(
    `tree/${reducerId}/setTreeSearchLoading`,
  ),
  setTreeSearchQuery: createAction<string>(
    `tree/${reducerId}/setTreeSearchQuery`,
  ),
}));
